import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { checkWin, utils } from "@alife/cone-arms-core";
var bindEvent = utils.bindEvent, getXPath = utils.getXPath;
var clickInfoList = [];
var getPosition = function(ele) {
    var offsetLeftALL = ele.offsetLeft + ele.clientLeft;
    var offsetTopALL = ele.offsetTop + ele.clientTop;
    if (ele.offsetParent) {
        var _getPosition = _sliced_to_array(getPosition(ele.offsetParent), 2), currentX = _getPosition[0], currentY = _getPosition[1];
        return [
            currentX + offsetLeftALL,
            currentY + offsetTopALL
        ];
    }
    return [
        ele.offsetLeft + ele.clientLeft,
        ele.offsetTop + ele.clientTop
    ];
};
var getFirstScreenClickTimes = function() {
    var firstScreenClickInfoList = clickInfoList.filter(function(item) {
        return item.isInFirstScreen;
    });
    return firstScreenClickInfoList.length;
};
export function init() {
    var unbindFnList = [];
    if (checkWin()) {
        unbindFnList.push(bindEvent(document, "mousedown", function(e) {
            // @ts-ignore 无法识别innerText 空节点不统计
            if (!e.target || !e.target.innerText) {
                return;
            }
            var _getPosition = _sliced_to_array(getPosition(e.target), 2), currentX = _getPosition[0], currentY = _getPosition[1];
            var offsetLeft = e.offsetX + currentX;
            var offsetTop = e.offsetY + currentY;
            clickInfoList.push({
                offsetLeft: offsetLeft,
                offsetTop: offsetTop,
                xpath: getXPath(e.target, 3),
                isInFirstScreen: offsetTop <= window.innerHeight && offsetLeft <= window.innerWidth,
                clickTimes: 1
            });
        }));
    }
    return function() {
        unbindFnList.forEach(function(unbindFn) {
            unbindFn();
        });
    };
}
export var reset = function() {
    clickInfoList = [];
};
export var getData = function() {
    if (clickInfoList.length === 0) {
        return {
            clickTimes: 0,
            firstScreenClickRate: 0
        };
    }
    var firstScreenClickTimes = getFirstScreenClickTimes();
    var mergeClickInfoMap = {};
    clickInfoList.forEach(function(item) {
        var xpath = item.xpath, offsetLeft = item.offsetLeft, offsetTop = item.offsetTop;
        var key = "".concat(xpath, "-").concat(offsetLeft, "-").concat(offsetTop);
        if (!mergeClickInfoMap[key]) {
            mergeClickInfoMap[key] = _object_spread_props(_object_spread({}, item), {
                clickTimes: 1
            });
        } else {
            mergeClickInfoMap[key].clickTimes += 1;
        }
    });
    return {
        firstScreenClickRate: firstScreenClickTimes / clickInfoList.length,
        clickTimes: clickInfoList.length,
        clickDetail: {
            clickInfoList: Object.keys(mergeClickInfoMap).map(function(key) {
                return mergeClickInfoMap[key];
            }),
            firstScreenClickTimes: firstScreenClickTimes
        }
    };
};

 //# sourceMappingURL=observe-page-click.js.map